import { TypedEvent } from '../../typed_event';
import ModalUtil from '../../util/modal_util';
import ReviewRepository from '../../repositories/review/review_repository';
import RedirectUtil from "../../../core/util/redirect_util";
import { DeleteReviewModel, FeedBackModel } from '../../models/review/review_js_env';

export class ReviewAreaAction {
  static readonly SEND_USEFULNESS = new TypedEvent<FeedBackModel>();

  // このレビューは参考になりましたか？のフィードバック
  static sendFeedbackUsefulness(model: FeedBackModel, isUseful: boolean) {
    if (!model.userId) {
      RedirectUtil.toLoginPage()
      return
  }

    if (model.feedbackUrl) {
      ReviewRepository.feedback(model.feedbackUrl, isUseful)
        .then((response) => {
          if (response && response.status === 200) {
            ReviewAreaAction.SEND_USEFULNESS.trigger({
              ...model,
              referenceTotal: response.data.total,
              referencePersons: response.data.useful,
              hasClick: true
            });
          }
        })
        .catch(() => {
          // TODO APIエラーの場合は何の対応？下記のコメントしたソースは、APIエラーでもUIを更新する例
          // console.log('API go wrong');
          // ItemAction.SEND_USEFULNESS.trigger({
          //   ...model,
          //   referenceTotal: model.referenceTotal + 1,
          //   referencePersons: isUseful ? model.referencePersons + 1 : model.referencePersons
          // });
        });
    }
  }

  // 削除用の共通はい・いいえモーダル。はいの場合は、Callback呼び出す
  static openDeleteReviewConfirmModal = (model: DeleteReviewModel) => {
    if (model.deleteUrl) {
      ModalUtil.confirm('このレビューを削除します。よろしいですか？', '削除', () => {
        ReviewRepository.deleteReview(model.deleteUrl as string)
          .then((response) => {
            if (response && response.status === 200) {
              document.getElementById(model.parentIdToDelete)?.remove();
            }
          })
          .catch(() => {
            // TODO APIエラーの場合は何の対応？下記のコメントしたソースは、APIエラーでもUIを更新する例
            // console.log('API go wrong');
            // document.getElementById(model.parentIdToDelete)?.remove();
          });
      });
    }
  };
}
